import axios from '@/plugins/axios';
import { snackBarError } from '@/utils/snackbar';

export default {
	async getAudits({ commit }, { id }) {
		try {
			commit('setLoading');
			commit('setAudits', []);
			const { data } = await axios(`/audit/all/${id}`, {
				method: 'get',
			});
			commit('setAudits', data.audits);
		} catch (error) {
			snackBarError(error)(commit);
		} finally {
			commit('setLoading');
		}
	},
	async getOneAudits({ commit }, { idPerson }) {
		try {
			commit('setOneAudits', null);
			const { data } = await axios(`/audit/${idPerson}`, {
				method: 'get',
			});
			commit('setOneAudits', data.audit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async getPersonWithAudit({ commit }) {
		try {
			commit('setOneAudits', null);
			const { data } = await axios(`/audit/personWithAudit`, {
				method: 'get',
			});
			commit('setPersonWithAudit', data.personWithAudit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
};
